"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class PhoneIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { id: "Symbols", stroke: fill, strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M19.4632741,15.6921359 L17.7188584,13.9477203 C17.0070117,13.2351624 15.8542609,13.2351624 15.1409919,13.9477203 L14.6737758,14.4149364 C12.8461573,12.9030621 11.0910747,11.1479794 9.58275609,9.32320551 L10.0499722,8.85598942 C10.7603966,8.14556496 10.7603966,6.98925848 10.0499722,6.27883402 L8.30555656,4.5344184 C7.59370983,3.82186053 6.44024789,3.82186053 5.72769002,4.5344184 L4.77050151,5.49089578 C3.88655997,6.37412619 3.74646625,7.77435218 4.43697892,8.81901037 C7.23458635,13.0481338 10.9488476,16.762395 15.1786821,19.5607136 C16.2098287,20.2419815 17.6022322,20.1310443 18.5060856,19.2264798 L19.4632741,18.2692913 C20.1772542,17.5567334 20.1744097,16.4018492 19.4632741,15.6921359" })))));
    }
}
exports.PhoneIcon = PhoneIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/phone.tsx
// module id = 2158
// module chunks = 0 1 2